import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { useDialog } from "lib/@hooks/useDialog"
import { invalidate } from "lib/graphql/cache"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { alert } from "lib/@dialogs/alert"
import { getFentraGroups } from "routes/qa/fentra/controllers/get-fentra-groups"
import { createFentraGroup } from "routes/qa/fentra/controllers/fentra-mutations"
import { FentraGroupRow } from "routes/qa/fentra/groups/fentra-group-row"
import { FentraGroupDialog } from "routes/qa/fentra/groups/fentra-group-dialog"

export function FentraGroupsTab() {
    const { target } = useBoundContext()
    const { _id: profileId } = target ?? {}
    const groups = getFentraGroups.useResults({ profileId }) ?? []
    const openGroupDialog = useDialog(<FentraGroupDialog />, { maxWidth: "sm", fullWidth: true })

    return (
        <Box sx={{ p: 3 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Typography variant="h6">Groups</Typography>
                <Button variant="contained" onClick={handleAddGroup}>
                    Add Group
                </Button>
            </Stack>

            <If value={groups.length > 0}>
                <Paper variant="outlined" sx={{ overflow: "hidden" }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Display Name</TableCell>
                                <TableCell>Members</TableCell>
                                <TableCell align="right" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <Repeat list={groups} item={<FentraGroupRow />} keyFn={groupKeyFn} pass="group" />
                        </TableBody>
                    </Table>
                </Paper>
                <Else>
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                        No groups yet.
                    </Typography>
                </Else>
            </If>
        </Box>
    )

    function groupKeyFn(g) {
        return g._id
    }

    async function handleAddGroup() {
        const data = await openGroupDialog({ mode: "create", profileId })
        if (!data) return
        const result = await createFentraGroup({ profileId, ...data })
        if (!result?.ok) {
            const msg = result?.scimStatus
                ? `Create failed (SCIM ${result.scimStatus}): ${result.error}`
                : `Create failed: ${result?.error ?? "Unknown error"}`
            await alert(msg, "Create Group")
            return
        }
        invalidate("fentraGroups")
        successSnackbar("Group created")
    }
}
